import { X, Download, Smartphone } from "lucide-react";
import { usePwaInstall } from "@/hooks/usePwaInstall";

export default function PwaInstallBanner() {
  const { canInstall, install, dismiss } = usePwaInstall();
  if (!canInstall) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-[360px] bg-gradient-to-br from-[#FDF9F1] to-white border border-[#C5A059] rounded-xl shadow-2xl p-4 z-50 flex items-start gap-3"
      data-testid="pwa-install-banner"
    >
      <div className="h-11 w-11 rounded-lg bg-white border border-[#C5A059]/30 flex items-center justify-center shrink-0">
        <Smartphone className="h-5 w-5 text-[#C5A059]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Installer O'SCOP GE
        </div>
        <p className="text-xs text-slate-600 mt-0.5">
          Accédez à vos feuilles de temps et documents depuis votre mobile — même hors réseau.
        </p>
        <div className="flex gap-2 mt-3">
          <button
            onClick={install}
            data-testid="pwa-install-btn"
            className="text-xs font-medium bg-[#C5A059] hover:bg-[#A88846] text-white px-3 py-1.5 rounded-md transition-colors flex items-center gap-1"
          >
            <Download className="h-3 w-3" /> Installer
          </button>
          <button
            onClick={dismiss}
            className="text-xs text-slate-500 hover:text-slate-700 px-2 py-1"
          >
            Plus tard
          </button>
        </div>
      </div>
      <button onClick={dismiss} className="text-slate-400 hover:text-slate-600 shrink-0" title="Fermer">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
